<template>
  <span class="status-badge" :class="status"><slot>{{ status }}</slot></span>
</template>

<script setup lang="ts">
defineProps<{ status: string }>();
</script>
